__webpack_require__.p = "https://trading-staging.iux.com/";